import React, { FC, useState } from 'react';
import { useFormik } from 'formik';
import {
	convertToInitialFundsReserveConfigValues, FUNDS_RESERVE_CONFIG_FORM_FIELDS, FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES,
	fundsReserveConfigInitialFields,
	getFormattedFundsReserveConfigFields,
	getFundsReserveConfigDetailsSchema, getInitialFundsReserveConfigFields,
} from '../../constants/funds-reserve-config/funds-reserve-config-form';
import { FundsReserveConfigInputs } from '../../constants/funds-reserve-config/funds-reserve-config-inputs';
import { FormInput } from '../merchants/FormInput';
import { InputType } from '../form/form-input-constants';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { setFundsReserveConfig } from '../../store/merchnts/actions/fundsReserveConfig';
import { isEqual } from 'lodash';

interface Props {
	id?: string;
	closeModal: () => void;
	onSuccess?: () => void;
	onError?: () => void;
}
export const ConfigurationForm: FC<Props> = (props) => {
	const { id, closeModal, onSuccess, onError } = props;

	const { merchantState: { fundsReserveConfigActiveListData, fundsReserveConfigLists }} = useMerchants();

	const data = fundsReserveConfigActiveListData?.find(el => el?.id === id);

	const [isLoading, setIsLoading] = useState<boolean>(false);
	const formik = useFormik({
		initialValues: id ? convertToInitialFundsReserveConfigValues(data) : fundsReserveConfigInitialFields,
		validationSchema: getFundsReserveConfigDetailsSchema,
		onSubmit: async () => {
			const formikData = getFormattedFundsReserveConfigFields(formik.values);
			const initialData = getInitialFundsReserveConfigFields(data);
			if (!isEqual(formikData, initialData)) {
				setIsLoading(true);
				await setFundsReserveConfig(formik, onSuccess, onError, id);
				setIsLoading(false);
			} else {
				closeModal();
			}
		}
	});

	const INPUTS = FundsReserveConfigInputs(fundsReserveConfigLists?.types, fundsReserveConfigLists?.rateTypes);
	return (
		<form onSubmit={formik.handleSubmit} className="row px-8">
			<FormInput
				formik={formik}
				fieldName={FUNDS_RESERVE_CONFIG_FORM_FIELDS.NAME}
				label={FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.NAME}
				placeholder={FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.NAME}
				inputType={InputType.Text}
				additionalClasses="col-md-6"
				required
				key={FUNDS_RESERVE_CONFIG_FORM_FIELDS.NAME}
			/>
			<div className="col-6"/>
			{INPUTS.map(item =>
        <FormInput
          {...item}
          formik={formik}
          key={item.key}
        />
			)}
			<div className="text-center my-5">
				<ButtonComponent
					buttonName="Cancel"
					buttonType={BUTTON_TYPE.CANCELLED}
					additionalClass="btn-sm"
					onButtonClick={closeModal}
				/>
				<ButtonComponent
					buttonName={id ? 'Edit' : 'Add'}
					type="submit"
					additionalClass="btn-sm ms-10 w-100px"
					loading={isLoading}
				/>
			</div>
		</form>
	);
};
